import React, { Component } from 'react'
import { UnauthorizedCard } from 'src/components/UnauthorizedCard'
import { Grid, Navbar } from '@softwaredev_cegeka/stix-core'
import logo from 'src/assets/images/logo-white.png'

class UnauthorizedPage extends Component {
    // keep this outside of the main routes so we don't loop indefinitely
    // when the user is unauthorized
    render() {
        const { noHeader, warningText } = this.props
        return (
            <>
                {noHeader ? null : (
                    <Navbar
                        fixed={'top'}
                        sticky={'top'}
                        bg={'primary'}
                        variant={'dark'}
                    >
                        <Navbar.Brand href={'/'}>
                            <img src={logo} alt={'Authorization logo'} />
                        </Navbar.Brand>
                    </Navbar>
                )}
                <Grid.Container className={'error-page'}>
                    <h1 className={'error-title'}>Unauthorized</h1>
                    <UnauthorizedCard
                        warningText={warningText ? warningText : undefined}
                    />
                </Grid.Container>
            </>
        )
    }
}

export default UnauthorizedPage
